export default __webpack_public_path__ + "static/media/ic_collapse.42093bc6.svg";